$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  let filterByFromQuery = $('body').attr('filter_by') || null;
  let startDateFromQuery =
    $('body').attr('start_date')?.replace('T', ' ') || null;
  let endDateFromQuery = $('body').attr('end_date')?.replace('T', ' ') || null;
  let customPeriodFromQuery = $('body').attr('custom_period') || null;
  let prevSelectedPeriodFromQuery =
    $('body').attr('prev_selected_period') || null;

  if (p === 'statistic_product') {
    setDateAndPeriod(
      startDateFromQuery,
      endDateFromQuery,
      filterByFromQuery,
      customPeriodFromQuery,
      prevSelectedPeriodFromQuery
    );
    let orderBy = 'name';
    let orderByDirection = 'asc';
    let customerId = 0;

    $(document).on('change', '#customer-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      customerId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('click', '.sort', function (e) {
      e.preventDefault();

      const $th = $(this);
      const parentTable = $th.closest('#product_table');
      const orderBy = $th.attr('data-order-by');
      let orderByDirection = $th.attr('data-order-by-direction');

      // Toggle direction
      orderByDirection = orderByDirection === 'asc' ? 'desc' : 'asc';

      // Reset other headers
      $th.siblings('.sort').each(function () {
        $(this).attr('data-order-by-direction', 'asc');
        const $otherIcon = $(this).find('.material-icons');
        $otherIcon
          .addClass('d-none')
          .removeClass('material-icons-asc')
          .text('sort');
      });

      // Update current header
      $th.attr('data-order-by-direction', orderByDirection);
      const $icon = $th.find('.material-icons');
      $icon.removeClass('d-none').text('sort');
      if (orderByDirection === 'asc') {
        $icon.addClass('material-icons-asc');
      } else {
        $icon.removeClass('material-icons-asc');
      }

      // Map orderBy to actual table column index
      const columnIndexMap = {
        name: 0,
        sku: 1,
        total_quantity: 2,
        total_price_ex_vat: 3,
        total_price_inc_vat: 4,
        degree_of_coverage: 5,
        total_coverage_contribution: 6,
        sold_price: 7,
      };

      const colIndex = columnIndexMap[orderBy];
      if (colIndex === undefined) return;

      const $tbody = parentTable.find('tbody');
      const $rows = $tbody.find('tr').not(':last'); // skip last total row
      const $totalRow = $tbody.find('tr:last');

      // Sort rows
      $rows.sort(function (a, b) {
        const $a = $(a).find('td:eq(' + colIndex + ')');
        const $b = $(b).find('td:eq(' + colIndex + ')');
        let aVal = $a.text().trim();
        let bVal = $b.text().trim();

        // Numeric columns (everything except name & sku)
        if (colIndex > 1) {
          // Parse EU-style numbers: "1.234,56" -> 1234.56
          aVal = parseFloat(aVal.replace(/\./g, '').replace(',', '.'));
          bVal = parseFloat(bVal.replace(/\./g, '').replace(',', '.'));
          if (isNaN(aVal)) aVal = 0;
          if (isNaN(bVal)) bVal = 0;
        }

        if (aVal < bVal) {
          return orderByDirection === 'asc' ? -1 : 1;
        } else if (aVal > bVal) {
          return orderByDirection === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      });

      // Re-append sorted rows + total row
      $tbody.empty().append($rows).append($totalRow);
    });

    $(document).on('change', '#custom-period', function (e) {
      e.preventDefault();
      customPeriod = $(this).val();
      if (customPeriod == 'day') {
        $('.custom-day-container').removeClass('d-none');
      } else {
        if (!$('.custom-day-container').hasClass('d-none')) {
          $('.custom-day-container').addClass('d-none');
        }
      }
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId,
        selectedDay
      );
    });

    $(document).on('change', '#top-product-group-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      $('#product-group-id')
        .selectpicker('val', ['all'])
        .selectpicker('refresh');
      topProductGroupUniqueId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('change', '#supplier-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      supplierId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('change', '#product-group-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));

      $('#top-product-group-id')
        .selectpicker('val', ['all'])
        .selectpicker('refresh');

      productGroupUniqueId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('change', '#product-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      productId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });
    $(document).on('change', '#product-category-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      productCategoryId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('change', '#user-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      userId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('change', '#payment-method', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      paymentMethod = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('change', '#location-id', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      locationId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('change', '#vat-code', function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      vatCode = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    $(document).on('change', '#platform', function (e) {
      e.preventDefault();
      platform = $(this).val();

      if (platform === 'self-service') {
        userId = 0;
        $('#user-id').val(userId);
        $('#user-id').prop('disabled', true);
      } else {
        $('#user-id').prop('disabled', false);
      }
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });
    $(document).on('click', '.period-button', function (e) {
      $('.period-button').removeClass('active');
      $(this).addClass('active');
      period = $(this).attr('data-value');
      prevSelectedPeriod = period !== 'custom' ? period : prevSelectedPeriod;
      $('#compare').prop('disabled', false);
      if (period === 'day') {
        startDate = moment().format('YYYY-MM-DD') + ' 00:00';
        endDate = moment().format('YYYY-MM-DD') + ' 23:59';
        const currentDayFormatted = moment().format('ddd - DD.MM.YYYY');
        customPeriod = 'time';
        $('#period-title').text(dayFormatAbbreviation(currentDayFormatted));
        if (compareBy && compareBy != 0) {
          compareBy = 'day-compare';
          $('#compare').val('day-compare').trigger('change.select2');
        }
      } else if (period === 'week') {
        startDate = moment().startOf('week').format('YYYY-MM-DD') + ' 00:00';
        endDate = moment().endOf('week').format('YYYY-MM-DD') + ' 23:59';
        const currentWeekNumber = moment().isoWeek();
        customPeriod = 'day';
        $(`#custom-period option[value="day"]`).prop('selected', true);
        $('#period-title').text('Uke nr' + ' ' + currentWeekNumber);
        if (compareBy && compareBy !== '0') {
          compareBy = 'week-compare';
          $('#compare').val('week-compare').trigger('change.select2');
        }
      } else if (period === 'month') {
        startDate = moment().startOf('month').format('YYYY-MM-DD') + ' 00:00';
        endDate = moment().endOf('month').format('YYYY-MM-DD') + ' 23:59';
        durationOfstartAndEndDate = 30;

        displayGraphDynamically(durationOfstartAndEndDate);
        if (isDesktop) {
          customPeriod = 'day';
          $(`#custom-period option[value="time"]`).prop('selected', false);
          $(`#custom-period option[value="day"]`).prop('selected', true);
        } else {
          customPeriod = 'week';
          $(`#custom-period option[value="day"]`).prop('selected', false);
          $(`#custom-period option[value="week"]`).prop('selected', true);
          $(`#custom-period option[value="day"]`).prop('disabled', true);
        }
        const currentMonth = moment().format('MMMM');
        $('#period-title').text(currentMonth);
        if (compareBy && compareBy !== '0') {
          compareBy = 'month-compare';
          $('#compare').val('month-compare').trigger('change.select2');
        }
      } else if (period === 'year') {
        startDate = moment().startOf('year').format('YYYY-MM-DD') + ' 00:00';
        endDate = moment().endOf('year').format('YYYY-MM-DD') + ' 23:59';
        displayGraphDynamically(365);
        customPeriod = 'month';
        $(`#custom-period option[value="time"]`).prop('selected', false);
        $(`#custom-period option[value="month"]`).prop('selected', true);
        $('#period-title').text(moment().format('YYYY'));

        $('#compare').prop('disabled', true);
      } else {
        $('#period-title').text('Custom');
        compareBy = null;
        $('#compare').val('0').trigger('change.select2');
        if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
          customPeriod = 'time';
          $("#custom-period option[value='time']").prop('selected', true);
          $('#custom-period').prop('disabled', true);
          $('#custom-period').val('time').trigger('change');
        } else {
          $("#custom-period option[value='time']").prop('disabled', true);
          $('#custom-period').prop('disabled', false);
        }
      }
      $('#start-date').val(startDate);
      $('#end-date').val(endDate);
      toggleCustomDatePicker();

      if (customPeriod == 'day') {
        $('.custom-day-container').removeClass('d-none');
      } else {
        if (!$('.custom-day-container').hasClass('d-none')) {
          $('.custom-day-container').addClass('d-none');
        }
      }
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    });

    function getDateAndTimeChange() {
      $('#start-date').datetimepicker({
        dateFormat: 'yy-mm-dd',
        timeFormat: 'HH:mm',
        showButtonPanel: true,
        regional: ['no', 'NO'],
        onClose: function () {
          if (startDate !== $(this).val()) {
            let choosenDate = $('#start-date').val();

            if (dateAndPeriodValidation(choosenDate, endDate)) {
              startDate = choosenDate;
              isDateChanged = true;

              if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
                $("#custom-period option[value='time']").prop('selected', true);
                $('#custom-period').prop('disabled', true);
                customPeriod = 'time';
              } else {
                durationOfstartAndEndDate = moment(endDate.split(' ')[0]).diff(
                  moment(startDate),
                  'days'
                );
                displayGraphDynamically(durationOfstartAndEndDate);
                $('#custom-period').prop('disabled', false);
                $("#custom-period option[value='time']").prop('disabled', true);
              }
              getOrderedProductQuantity(
                startDate,
                endDate,
                period,
                supplierId,
                productGroupUniqueId,
                locationId,
                userId,
                platform,
                orderBy,
                orderByDirection,
                customPeriod,
                customerId,
                topProductGroupUniqueId,
                compareBy,
                productId,
                vatCode,
                paymentMethod,
                productCategoryId
              );
              prevSelectedPeriod = 'custom';
              $('#period-title').text(
                moment(startDate).format('DD-MM-YYYY') +
                  ' : ' +
                  moment(endDate).format('DD-MM-YYYY')
              );
            }
          }
        },
      });

      // Initialize the Datepicker for end-date
      $('#end-date').datetimepicker({
        dateFormat: 'yy-mm-dd',
        timeFormat: 'HH:mm',
        showButtonPanel: true,
        onClose: function () {
          if (endDate !== $(this).val()) {
            let currentendDate = $('#end-date').val();
            if (dateAndPeriodValidation(startDate, currentendDate)) {
              isDateChanged = true;
              endDate = currentendDate;

              if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
                $("#custom-period option[value='time']").prop('selected', true);
                $('#custom-period').prop('disabled', true);
                customPeriod = 'time';
              } else {
                durationOfstartAndEndDate = moment(endDate).diff(
                  moment(startDate.split(' ')[0]),
                  'days'
                );
                displayGraphDynamically(durationOfstartAndEndDate);

                $('#custom-period').prop('disabled', false);
                $("#custom-period option[value='time']").prop('disabled', true);
              }
              getOrderedProductQuantity(
                startDate,
                endDate,
                period,
                supplierId,
                productGroupUniqueId,
                locationId,
                userId,
                platform,
                orderBy,
                orderByDirection,
                customPeriod,
                customerId,
                topProductGroupUniqueId,
                compareBy,
                productId,
                vatCode,
                paymentMethod,
                productCategoryId
              );
              prevSelectedPeriod = 'custom';
              $('#period-title').text(
                moment(startDate).format('DD-MM-YYYY') +
                  ' : ' +
                  moment(endDate).format('DD-MM-YYYY')
              );
            }
          }
        },
      });
    }

    $(document).on('click', '#previous-button', function (e) {
      e.preventDefault();
      let periodTitle = '';
      if (
        period === 'day' ||
        (prevSelectedPeriod === 'day' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = dayFormatAbbreviation(
          moment(startDate).format('ddd - DD.MM.YYYY')
        );
      }
      if (
        period === 'week' ||
        (prevSelectedPeriod === 'week' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).subtract(1, 'week').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).subtract(1, 'week').format('YYYY-MM-DD') + ' 23:59';
        const currentWeekNumber = moment(startDate).isoWeek();
        periodTitle = 'Uke nr' + ' ' + currentWeekNumber;
      }

      if (
        period === 'month' ||
        (prevSelectedPeriod === 'month' &&
          !isDateChanged &&
          period === 'custom')
      ) {
        startDate =
          moment(startDate).subtract(1, 'month').format('YYYY-MM-DD') +
          ' 00:00';
        endDate =
          period === 'month'
            ? moment(endDate)
                .subtract(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD') + ' 23:59'
            : moment(endDate).subtract(1, 'month').format('YYYY-MM-DD') +
              ' 23:59';
        periodTitle = moment(startDate).format('MMMM');
      }

      if (
        period === 'year' ||
        (prevSelectedPeriod === 'year' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).subtract(1, 'year').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).subtract(1, 'year').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = moment(startDate).format('YYYY');
      }

      if (period === 'custom' && prevSelectedPeriod === 'custom') {
        let previousStartDate = moment(startDate);
        let previousEndDate = moment(endDate);

        endDate =
          moment(startDate).subtract(1, 'day').format('YYYY-MM-DD') + ' 23:59';

        durationOfstartAndEndDate = previousEndDate.diff(
          previousStartDate,
          'days'
        );

        startDate =
          moment(endDate)
            .subtract(durationOfstartAndEndDate, 'days')
            .format('YYYY-MM-DD') + ' 00:00';
        periodTitle =
          moment(startDate).format('DD-MM-YYYY') +
          ' : ' +
          moment(endDate).format('DD-MM-YYYY');
      }
      $('#start-date').val(startDate);
      $('#end-date').val(endDate);
      $('#period-title').text(periodTitle);
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
      if (compareBy && compareBy == 'day-compare') {
        let $compare = $('#compare');
        let dayCompareOption = $compare.find("option[value='day-compare']");

        if (dayCompareOption.length) {
          dayCompareOption.text(
            `i dag / forrige ${getPeriodTranslation(compareBy, startDate)}`
          );
          $compare.val('day-compare');
          $compare.trigger('change.select2');
          $compare.select2('destroy');
          $compare.select2({ theme: 'bootstrap4' });
        }
      }
    });

    $(document).on('click', '#next-button', function (e) {
      e.preventDefault();
      let periodTitle = '';
      if (
        period === 'day' ||
        (prevSelectedPeriod === 'day' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).add(1, 'day').format('YYYY-MM-DD') + ' 00:00';
        endDate = moment(endDate).add(1, 'day').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = dayFormatAbbreviation(
          moment(startDate).format('ddd - DD.MM.YYYY')
        );
      }
      if (
        period === 'week' ||
        (prevSelectedPeriod === 'week' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).add(1, 'week').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).add(1, 'week').format('YYYY-MM-DD') + ' 23:59';
        const currentWeekNumber = moment(startDate).isoWeek();
        periodTitle = 'Uke nr' + ' ' + currentWeekNumber;
      }

      if (
        period === 'month' ||
        (prevSelectedPeriod === 'month' &&
          !isDateChanged &&
          period === 'custom')
      ) {
        startDate =
          moment(startDate).add(1, 'month').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          period === 'month'
            ? moment(endDate)
                .add(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD') + ' 23:59'
            : moment(endDate).add(1, 'month').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = moment(startDate).format('MMMM');
      }

      if (
        period === 'year' ||
        (prevSelectedPeriod === 'year' && !isDateChanged && period === 'custom')
      ) {
        startDate =
          moment(startDate).add(1, 'year').format('YYYY-MM-DD') + ' 00:00';
        endDate =
          moment(endDate).add(1, 'year').format('YYYY-MM-DD') + ' 23:59';
        periodTitle = moment(startDate).format('YYYY');
      }

      if (period === 'custom' && prevSelectedPeriod === 'custom') {
        let previousStartDate = moment(startDate);
        let previousEndDate = moment(endDate);

        startDate =
          moment(endDate).add(1, 'day').format('YYYY-MM-DD') + ' 00:00';

        durationOfstartAndEndDate = previousEndDate.diff(
          previousStartDate,
          'days'
        );

        endDate =
          moment(startDate)
            .add(durationOfstartAndEndDate, 'days')
            .format('YYYY-MM-DD') + ' 23:59';
        periodTitle =
          moment(startDate).format('DD-MM-YYYY') +
          ' : ' +
          moment(endDate).format('DD-MM-YYYY');
      }
      $('#start-date').val(startDate);
      $('#end-date').val(endDate);
      $('#period-title').text(periodTitle);
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
      if (compareBy && compareBy == 'day-compare') {
        let $compare = $('#compare');
        let dayCompareOption = $compare.find("option[value='day-compare']");

        if (dayCompareOption.length) {
          dayCompareOption.text(
            `i dag / forrige ${getPeriodTranslation(compareBy, startDate)}`
          );
          $compare.val('day-compare');
          $compare.trigger('change.select2');
          $compare.select2('destroy');
          $compare.select2({ theme: 'bootstrap4' });
        }
      }
    });

    function eventLineChart(categoryArray, seriesData1, seriesData2) {
      const { legendText, previousLegendText } = getLegendTexts(
        compareBy,
        startDate
      );
      // Calculate totals for series
      const total1 = seriesData1.reduce((sum, val) => sum + parseFloat(val), 0);
      const total2 = seriesData2
        ? seriesData2.reduce((sum, val) => sum + parseFloat(val), 0)
        : 0;

      // Render the chart
      chartComponent = Highcharts.chart('event-line-graph', {
        chart: {
          type: 'column',
        },
        title: {
          text: null,
        },
        exporting: { enabled: false },
        plotOptions: {
          series: {
            lineWidth: 4,
          },
        },

        xAxis: {
          categories: categoryArray,
          labels: {
            formatter: function () {
              if (customPeriod === 'day') {
                return Highcharts.dateFormat(
                  '%e/%b',
                  new Date(this.value).getTime()
                );
              } else if (customPeriod === 'week') {
                return 'Uke ' + this.value;
              } else if (customPeriod === 'month') {
                return Highcharts.dateFormat(
                  '%B %Y',
                  new Date(this.value).getTime()
                );
              } else {
                return this.value;
              }
            },
          },
        },
        credits: { enabled: false },
        yAxis: {
          title: {
            text: 'Antall varer',
          },
        },
        series:
          !compareBy || compareBy == '0'
            ? [
                {
                  name: `Antall varer ( ${total1} ) `,
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    parseFloat(value),
                  ]),
                },
              ]
            : [
                {
                  name: `Antall varer ( ${total1} ) ${legendText}`,
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    parseFloat(value),
                  ]),
                },
                {
                  name: `Antall varer forrige ${getPeriodTranslation(
                    compareBy ?? '',
                    startDate
                  )} ( ${total2} ) ${previousLegendText}`,
                  data: seriesData2.map((value, index) => [
                    categoryArray[index],
                    parseFloat(value),
                  ]),
                },
              ],
        tooltip: {
          formatter: function () {
            var tooltipText;
            if (startDate.split(' ')[0] === endDate.split(' ')[0]) {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%H:%M, %b %e', this.x) +
                '</b><br/>' +
                'Antall varer : ' +
                formatNumber(this.y);
            } else if (customPeriod === 'week') {
              tooltipText =
                '<b>' +
                'Uke' +
                ' ' +
                this.x +
                '</b><br/>' +
                'Antall varer : ' +
                formatNumber(this.y);
            } else if (customPeriod === 'month') {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%B - %Y', this.x) +
                '</b><br/>' +
                'Antall varer : ' +
                formatNumber(this.y);
            } else {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%A, %b %e, %Y', this.x) +
                '</b><br/>' +
                'Antall varer : ' +
                formatNumber(this.y);
            }
            return tooltipText;
          },
        },
      });
    }

    function dateAndPeriodValidation(startedDate, endedDate) {
      let start = moment(startedDate);
      let end = moment(endedDate);
      durationOfstartAndEndDateByMonths = moment(endedDate.split(' ')[0]).diff(
        startedDate.split(' ')[0],
        'months'
      );

      if (start.isAfter(end)) {
        $('#start-date').val(startDate);
        $('#end-date').val(endDate);
        return alert('end date cannot be later than start date');
      } else if (durationOfstartAndEndDateByMonths > 36) {
        $('#start-date').val(startDate);
        $('#end-date').val(endDate);
        return alert('Maksimal varighet er 3 år');
      } else {
        return true;
      }
    }
    $(document).on('change', '#compare', function (e) {
      e.preventDefault();
      compareBy = $(this).val();
      if (compareBy === 'day-compare') {
        period = 'day';
      } else if (compareBy === 'week-compare') {
        period = 'week';
      } else if (compareBy === 'month-compare') {
        period = 'month';
      } else {
        compareBy = null;
      }
      $(`.period-button[data-value='${period}']`).trigger('click');
    });

    $(document).on('change', '#custom-day', function (e) {
      e.preventDefault();
      selectedDay = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        customerId,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId,
        selectedDay
      );
    });
    function getOrderedProductQuantity(
      startDate,
      endDate,
      period = null,
      supplierId = null,
      productGroupUniqueId = null,
      locationId = null,
      userId = null,
      platform = 'all',
      orderBy,
      orderByDirection,
      customPeriod,
      customerId,
      topProductGroupUniqueId = 0,
      compareBy = null,
      productId = 0,
      vatCode = 0,
      paymentMethod = 0,
      productCategoryId = 0,
      selectedDay = null
    ) {
      $.ajax({
        type: 'POST',
        url: '/ajax/statistic_product/search',
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          orderBy,
          orderByDirection,
          customPeriod,
          customerId,
          topProductGroupUniqueId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          productCategoryId,
          selectedDay,
        },
      })
        .done(function (data) {
          if (data) {
            if (data.totalQuantity) {
              $('#key-figure-text').text(parseFloat(data.totalQuantity));
              total1 = parseFloat(data.totalQuantity);
            } else {
              $('#key-figure-text').text(0);
            }
            if (
              data.xAxisArray.length > 0 &&
              data.seriesData1 &&
              data.seriesData2
            ) {
              exportDateData = data.xAxisArray;
              exportProductData = data.seriesData1;
              eventLineChart(
                data.xAxisArray,
                data.seriesData1,
                data.seriesData2
              );
            }
            if (data.html) {
              $('#product-list-table').empty;
              $('#product-list-table').html(data.html);
            }
          }
          let aTags = $('.statistic-tab-group a');
          aTags.each(function () {
            let oldHref = $(this).attr('href').split('?')[0];
            let newHref =
              oldHref +
              `?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
            $(this).prop('href', newHref);
          });
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    let total1 = 0;
    let exportDateData = [];
    let exportProductData = [];
    let htmlData = [];
    $(document).on('click', '#download-statistic-excel', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
      htmlData = getProductHtmlData();
      $.ajax({
        url: '/api/v1/private/statistics/download-statistic-excel',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          export_date_data: exportDateData,
          export_product_data: exportProductData,
          export_type: 'product',
          html_data: htmlData,
          total_product: total1,
        }),
        xhrFields: { responseType: 'blob' }, // important for binary data
        success: function (data) {
          if (window.ReactNativeWebView) {
            // Convert blob to base64
            const reader = new FileReader();
            reader.onloadend = function () {
              const base64Data = reader.result.split(',')[1];
              const filename = `Statistikk vare (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;

              // Send to React Native
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: 'download',
                  data: {
                    base64Data,
                    filename: filename,
                    mimeType:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  },
                })
              );
            };
            reader.readAsDataURL(data);
          } else {
            const blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Statistikk vare (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`; // your filename
            link.click();
          }
        },
        error: function () {
          alert('Error generating Excel file');
        },
        complete: function () {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Last ned(excel)');
        },
      });
    });

    $(document).on('click', '#download-statistic-pdf', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
      htmlData = getProductHtmlData();
      if (!chartComponent) {
        alert('Chart not ready');
        disabledOnClick.prop('disabled', false).html('Last ned(pdf)');
        return;
      }

      // Convert Highcharts SVG to PNG
      const svg = chartComponent.getSVG();
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const pngData = canvas.toDataURL('image/png'); // base64 PNG

        // Prepare payload using your Excel-style fields + chart PNG
        const payload = {
          export_date_data: exportDateData,
          export_product_data: exportProductData,
          export_type: 'product',
          html_data: htmlData,
          total_product: total1,
          chart_png: pngData, // PNG included
        };

        // AJAX POST to generate PDF
        $.ajax({
          url: '/api/v1/private/statistics/download-statistic-pdf',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(payload),
          xhrFields: { responseType: 'blob' }, // receive PDF
          success: function (data) {
            if (window.ReactNativeWebView) {
              // Convert blob to base64
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
                const filename = `Statistikk vare (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;

                // Send to React Native
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    action: 'download',
                    data: {
                      base64Data,
                      filename: filename,
                      mimeType: 'application/pdf',
                    },
                  })
                );
              };
              reader.readAsDataURL(data);
            } else {
              const blob = new Blob([data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `Statistikk vare (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;
              link.click();
            }
          },
          error: function () {
            alert('Error generating PDF');
          },
          complete: function () {
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html('Last ned(pdf)');
          },
        });
      };

      // Encode SVG for PNG conversion
      img.src =
        'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
    });

    function getProductHtmlData() {
      var $table = $('#product_table');
      var headers = [];

      // Get headers
      $table.find('thead th').each(function () {
        let headerText = $(this)
          .clone()
          .children('i')
          .remove()
          .end()
          .text()
          .trim();
        headers.push(headerText);
      });

      var htmlData = [];

      // Get rows
      $table.find('tbody tr').each(function () {
        var $cells = $(this).find('td');
        var rowData = {};
        var skipRow = false;

        $cells.each(function (index) {
          var cellText = $(this).text().trim();
          if (cellText === 'Totalt') {
            skipRow = true; // skip the summary row
          }
          rowData[headers[index]] = cellText;
        });

        if (!skipRow && Object.values(rowData).some((val) => val !== '')) {
          htmlData.push(rowData);
        }
      });

      return htmlData;
    }

    function toggleCustomDatePicker() {
      let customDatePicker = $('.custom-date-picker');

      if (period === 'custom') {
        customDatePicker.show();
      } else {
        customDatePicker.hide();
      }
    }
    getOrderedProductQuantity(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      orderBy,
      orderByDirection,
      customPeriod,
      customerId,
      topProductGroupUniqueId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
    toggleCustomDatePicker();
    getDateAndTimeChange();
  }
});
